import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged, fromEvent } from 'rxjs';
import { ListColumn } from './list-column.model';

@Component({
    selector: 'app-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ListComponent implements AfterViewInit, OnInit  {

  @Input() name: string = '';
  @Input() columns: ListColumn[] = [];
  @Input() addBut: boolean = false;
  @Input() button_name: string = '';
  @Input() hideFilter: boolean = false;

  @ViewChild('filter') filter: ElementRef | undefined;
  @Output() filterChange = new EventEmitter<string>();
  @Output() addActive = new EventEmitter<boolean>();

  @Input() hideHeader: boolean = false;
  @Input() filterArray: any = [{id: 0, name: ''}];
  @Input() hasFilter: boolean = false;
  form?: UntypedFormGroup;

  @Output() filterComboChange = new EventEmitter<number>();

  constructor(private readonly fb: UntypedFormBuilder, ) {

  }
  ngOnInit(): void {
    this.form = this.fb.group({
      search: ['', []],
    });

    this.form.get("search")?.valueChanges.subscribe(x => {
      this.filterComboChange.emit(x);
   })

  }

  ngAfterViewInit() {
    
    if (!this.hideHeader && this.filter != undefined) {
      fromEvent(this.filter?.nativeElement, 'keyup').pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe(() => {
        if (this.filter?.nativeElement.value && this.filter?.nativeElement.value.length > 2) {
          this.filterChange.emit(this.filter?.nativeElement.value);
        } else if (this.filter?.nativeElement.value.length == 0) {
          this.filterChange.emit(this.filter?.nativeElement.value);
        }
      });
    }
  }

  toggleColumnVisibility(column: any, event: any) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    column.visible = !column.visible;
  }

  sendAddButton(){
    this.addActive.emit(true);
  }

}
